var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.88 103.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.59,80.06l-8.34,9,3.22,3.35a6.62,6.62,0,0,1-.18,9.36h0a6.62,6.62,0,0,1-9.36-.19L18.14,88.26,37.36,70.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.38,79.42A6.62,6.62,0,0,0,76,79.23l-3.35,3.22L59.28,68.58C69.1,59.07,83.72,43.35,83.72,32a32,32,0,1,0-64,0c0,17.68,35.53,52.24,35.53,52.24l16.65,17.32,13.3-12.79A6.62,6.62,0,0,0,85.38,79.42ZM51.88,43.37a12.21,12.21,0,1,1,12.2-12.2A12.21,12.21,0,0,1,51.88,43.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.53,47.84a2.29,2.29,0,0,1-2-1.23,33.45,33.45,0,0,1,.15-31.18,2.3,2.3,0,0,1,4,2.17,28.79,28.79,0,0,0-3.39,13.57,28.43,28.43,0,0,0,3.25,13.31,2.29,2.29,0,0,1-1,3.1A2.24,2.24,0,0,1,14.53,47.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.22,47.84a2.24,2.24,0,0,1-1.06-.26,2.3,2.3,0,0,1-1-3.1,28.43,28.43,0,0,0,3.25-13.31A28.9,28.9,0,0,0,87.06,17.6a2.29,2.29,0,1,1,4-2.17,33.45,33.45,0,0,1,.15,31.18A2.28,2.28,0,0,1,89.22,47.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.25,43a2.24,2.24,0,0,1-1.06-.26,2.3,2.3,0,0,1-1-3.1,18.17,18.17,0,0,0,2.08-8.5,18.35,18.35,0,0,0-2.17-8.66,2.3,2.3,0,0,1,4.05-2.17,23.05,23.05,0,0,1,.1,21.46A2.28,2.28,0,0,1,99.25,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.64,43a2.3,2.3,0,0,1-2-1.23,23,23,0,0,1,.11-21.46,2.29,2.29,0,1,1,4,2.17,18.46,18.46,0,0,0-2.16,8.66,18.17,18.17,0,0,0,2.08,8.5,2.31,2.31,0,0,1-1,3.1A2.27,2.27,0,0,1,4.64,43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/LogoWhite.cda907886c4c0cceeb27b75a87669212.svg";
export { ForwardRef as ReactComponent };